import { render } from "./HomeUserList.vue?vue&type=template&id=6132c89c&scoped=true"
import script from "./HomeUserList.vue?vue&type=script&lang=js"
export * from "./HomeUserList.vue?vue&type=script&lang=js"

import "./HomeUserList.vue?vue&type=style&index=0&id=6132c89c&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6132c89c"]])

export default __exports__